import type { PropsWithChildren } from 'react'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '@/analytics/events'
import { initPostHogAnalytics } from '@/analytics/posthog'
import { registerWebVitalsReporting } from '@/analytics/webVitals'

export function PostHogAnalytics({ children }: PropsWithChildren) {
  const location = useLocation()
  const previousPath = useRef<string | null>(null)

  useEffect(() => {
    initPostHogAnalytics()
    registerWebVitalsReporting()
  }, [])

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`

    if (previousPath.current === path) {
      return
    }

    previousPath.current = path

    trackEvent('app_page_viewed', {
      path: location.pathname,
      ...(location.search ? { search: location.search } : {}),
      ...(location.hash ? { hash: location.hash } : {}),
    })
  }, [location.hash, location.pathname, location.search])

  return <>{children}</>
}
